import { bootstrapApplication } from '@angular/platform-browser';
import { mergeApplicationConfig } from '@angular/core';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { APP_CONFIG, loadAppConfig } from './app/core/app-config';
import { provideDefaultClient } from './api';

loadAppConfig()
  .then((config) =>
    bootstrapApplication(
      App,
      mergeApplicationConfig(appConfig, {
        providers: [{ provide: APP_CONFIG, useValue: config }, provideDefaultClient({ basePath: config.httpUrl })],
      }),
    ),
  )
  .catch((err) => console.error(err));
